module.exports = __webpack_public_path__ + "static/achieveIcon_3-172ffd6f886d026e5530db1a2c752af8.png";